import {ServiceClass} from '@/decorators';
import {Backup, BackupSettings} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class BackupApi extends BaseApi {
    public getBackupSettings(userId: string) {
        return this.GET_RequestAsync<BackupSettings>(`${this.ApiUrl}/backup/settings/${userId}`);
    }

    public createOrUpdateBackupSettings(userId: string, settings: Omit<BackupSettings, 'id' | 'created' | 'updated' | 'userId'>) {
        return this.POST_RequestAsync<BackupSettings>(`${this.ApiUrl}/backup/settings/${userId}`, settings);
    }

    public getBackups(userId: string) {
        return this.GET_RequestAsync<Backup[]>(`${this.ApiUrl}/backup/user/${userId}`);
    }

    public createBackup(userId: string) {
        return this.POST_RequestAsync<Backup>(`${this.ApiUrl}/backup/${userId}`, {});
    }

    public restoreBackup(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.POST_FileRequestAsync<void>(`${this.ApiUrl}/backup/restore`, formData);
    }

    public getBackupById(id: string) {
        return this.GET_RequestAsync<Backup>(`${this.ApiUrl}/backup/${id}`);
    }

    public deleteBackupById(id: string) {
        return this.DELETE_RequestAsync<void>(`${this.ApiUrl}/backup/${id}`);
    }

    public downloadBackup(id: string) {
        return this.GET_RequestAsync<any>(`${this.ApiUrl}/backup/download/${id}`);
    }
}
